import React, { Component } from "react";
import "./_teams.scss";
import DevelopmentTeam from "./development-team";
import BusinessTeam from "./business-team";
import AdvisorsTeam from "./advisors-team";

class Teams extends Component {
  render() {
    return (
      <section id="teams">
        <div className="row m-0">
          <div className="col-12 teams-head-wrapper text-center">
            <span>
              <img
                className="img-fluid"
                src={require("../../assets/icons/teams.png")}
              />
              Teams
            </span>
          </div>
        </div>
        <div className="mb-5">
          <DevelopmentTeam />
        </div>
        <div className="">
          <BusinessTeam />
        </div>
        <div className="">
          <AdvisorsTeam />
        </div>
      </section>
    );
  }
}

export default Teams;
